/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { gettHeaderByType, settHeaderByType } from '@/api/common'
import {
    getFinanceRefundList,
    setFinanceRefundStatus,
    delFinanceRefundById,
    financeRefundExportData,
    syncFinanceRefundToEkuaibao, getFinanceBackMoneyProofByFinanceRefundId
} from '@/api/financial-center'
import { UserModule } from '@/store/modules/user'
import { formatDate } from '@/utils/timeFilter'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class Refund extends Vue {
    tableData = []
    tableHeadData = []
    tableHeadPopoverShow = false
    tableLoading = false
    // tableRandom = Math.random()
    total = 0
    page = 1
    limit = 20
    cancelApproveDialog = false
    action = '0'
    reviewId = NaN
    delRefundId = NaN
    delRefundDialogShow = false

    tableHeaderFilter: {
        mainPart?: string;
        mainPartName?: string;
        directorUserIdList?: string[];
        status?: '';
        refundAt?: Date[];
        code?: string;
        financeOrderCode?: string;
        payStatus: string
    } = {
        mainPart: '',
        mainPartName: '',
        directorUserIdList: [],
        status: '',
        refundAt: [],
        code: '',
        financeOrderCode: '',
        payStatus: ''
    }
    exportButtonDisabled = false
    tableKey = Math.random()
    syncVisible = false
    refundId = ''
    timer = null
    // isReadonly = false
    draggableList = []
    draggableListChange = []
    dialogVisible = false
    fileList = []

    created() {
        this.gettHeaderByType()
    }
    menuBtn = menuBtn // 按钮权限验证
    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }
    async gettHeaderByType() {
        const { headerUserList } = await gettHeaderByType(11) as unknown as { headerUserList: any[] }
        this.draggableList = headerUserList
        this.tableHeadData = JSON.parse(JSON.stringify(headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(headerUserList))
        this.getTableData()
    }

    async getTableData() {
        this.tableLoading = true

        const obj = {
            mainPart: '',
            mainPartName: '',
            directorUserIdList: [],
            status: '',
            refundAt: '',
            code: '',
            financeOrderCode: '',
            payStatus: ''
        }
        for(const key in obj) {
            if(key === 'refundAt') {
                obj[key] = this.tableHeaderFilter[key] && this.tableHeaderFilter[key][0] && this.tableHeaderFilter[key].length > 0 ? formatDate('yyyy-MM-dd', new Date(this.tableHeaderFilter[key][0])) + '/' + formatDate('yyyy-MM-dd', this.tableHeaderFilter[key][1]) : ''
            } else {
                obj[key] = this.tableHeaderFilter[key]
            }
            // console.log(key, `obj.key:${obj[key]}`, `formData.key:${this.tableHeaderFilter[key]}`);
            if(!obj[key] || obj[key].length === 0) delete obj[key]
        }

        const { allNum, financeRefundList } = await getFinanceRefundList({ ...obj, limit: this.limit, page: this.page })
        this.tableData = financeRefundList

        // this.tableData.forEach(item => {
        //     if (item.finance_refund_account) {
        //         item.finance_refund_accountStatus = item.finance_refund_account.status
        //     }
        // })

        this.total = allNum
        this.tableLoading = false
        // this.isReadonly = false
        this.tableKey = Math.random()
        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
    }

    async exportExcel() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const obj = {
            mainPart: '',
            mainPartName: '',
            directorUserIdList: [],
            status: '',
            refundAt: '',
            code: '',
            financeOrderCode: '',
            payStatus: ''
        }
        for(const key in obj) {
            if(key === 'refundAt') {
                obj[key] = this.tableHeaderFilter[key][0] && this.tableHeaderFilter[key].length > 0 ? formatDate('yyyy-MM-dd', new Date(this.tableHeaderFilter[key][0])) + '/' + formatDate('yyyy-MM-dd', this.tableHeaderFilter[key][1]) : ''
            } else {
                obj[key] = this.tableHeaderFilter[key]
            }
            if(!obj[key] || obj[key].length === 0) delete obj[key]
        }
        financeRefundExportData(obj).finally(() => {
            this.exportButtonDisabled = false
        })
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }
    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({
                headerIds: this.draggableList,
                types: 11
            })
            this.tableHeadPopoverShow = false
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel(){
        this.draggableListChange =JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false
    }

    setFinanceRefundStatus(row, action: string) {
        this.reviewId = row.id
        this.action = action
        if(action === '0') {
            const win = window.open(window.location.origin + '/financialCenter/newRefund?refundId=' + row.id + '&isUpdatedData=1')
            const timer = setInterval(() => {
                if(win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        } else {
            this.cancelApproveDialog = true
        }
    }

    async clickCancelApproveDialogConfirmButton() {
        await setFinanceRefundStatus({
            id: this.reviewId,
            action: this.action,
        })
        this.$message.success(`成功${this.action === '0' ? '提交' : '撤回'}审批`)
        this.getTableData()
        this.cancelApproveDialog = false
    }



    async delFinanceRefundById(row) {
        this.delRefundId = row.id
        this.delRefundDialogShow = true
    }

    async delRefundDialogConfirm() {
        await delFinanceRefundById(this.delRefundId)
        this.$message.success('删除成功')
        this.delRefundId = NaN
        this.delRefundDialogShow = false
        this.getTableData()
    }

    clickNewRefundButton() {
        const win = window.open('/financialCenter/newRefund', '_blank')
        const timer = setInterval(() => {
            if(win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        })
    }

    clickTableRow(row, col) {
        if(col && col.label === '操作') return
        const win = window.open(window.location.origin + '/financialCenter/refundInfo?refundId=' + row.id + '&status=' + row.status + '&isUpdatedData=0')
        const timer = setInterval(() => {
            if(win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    computedWidth(cnFilds: string) {
        const obj = {
            '订单编号': '160',
            '本次退款金额': '100',
            '期待退款时间': '120',
            '退款编号': '160'
        }
        return obj[cnFilds] ? obj[cnFilds]: ''
    }

    clickEditButton(row) {
        const win = window.open(window.location.origin + '/financialCenter/newRefund?refundId=' + row.id + '&isUpdatedData=0')
        const timer = setInterval(() => {
            if(win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    // 跳转统计图表页面
    goToDtatisticsData() {
        const { origin } = window.location
        const src = origin + '/financialCenter/refundReport'
        window.open(src, '_blank')
    }


    syncData(row){
        this.refundId = row.id
        this.syncVisible = true
    }

    async syncDialogConfirm() {
        this.syncVisible = false
        await syncFinanceRefundToEkuaibao({id: this.refundId})
        this.$message.success('同步单据成功')
    }

    changeDirectorUserIdList(e) {
        this.tableHeaderFilter.directorUserIdList = e.id
        if(!e.id){

        }
        this.page = 1
        this.getTableData()
    }

    handleViewBackMoney(row) {
        getFinanceBackMoneyProofByFinanceRefundId({financeRefundId: row.id}).then((res: any) => {
            this.fileList =  res.financeBackMoneyProofList
            this.dialogVisible = true
        }).catch(err => {
            this.dialogVisible = false
        })
    }

    doDialogVisibleCancel() {
        this.dialogVisible = false
    }
}
